"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffDealVersions = diffDealVersions;
const money = (cents) => typeof cents === 'number' ? `$${(cents / 100).toFixed(2)}` : null;
const percent = (n) => (typeof n === 'number' ? `${n}%` : null);
function diffDealVersions(a, b) {
    const out = [];
    const push = (path, label, before, after, impact) => {
        if (before !== after)
            out.push({ path, label, before, after, impact });
    };
    // ── price phases, positionally ──
    const phases = Math.max(a.pricePhases.length, b.pricePhases.length);
    for (let i = 0; i < phases; i++) {
        const pa = a.pricePhases[i], pb = b.pricePhases[i];
        push(`pricePhases[${i}].amountCents`, `Price phase ${i + 1}`, money(pa?.amountCents), money(pb?.amountCents), 'money');
        push(`pricePhases[${i}].months`, `Price phase ${i + 1} length`, pa?.months != null ? `${pa.months} months` : null, pb?.months != null ? `${pb.months} months` : null, 'money');
    }
    // ── documents, keyed by documentId so add/remove read correctly ──
    const ids = new Set([...a.documents.map(d => d.documentId), ...b.documents.map(d => d.documentId)]);
    for (const id of ids) {
        const da = a.documents.find(d => d.documentId === id);
        const db = b.documents.find(d => d.documentId === id);
        push(`documents.${id}.versionNo`, id, da ? `v${da.versionNo}` : null, db ? `v${db.versionNo}` : null, 'legal');
        if (da && db) {
            push(`documents.${id}.required`, `${id} required`, String(da.required), String(db.required), 'legal');
        }
    }
    // ── commission ──
    push('commissionPlan.planId', 'Commission plan', a.commissionPlan.planId, b.commissionPlan.planId, 'money');
    push('commissionPlan.softwareRatePercent', 'Software commission rate', percent(a.commissionPlan.softwareRatePercent), percent(b.commissionPlan.softwareRatePercent), 'money');
    push('commissionPlan.hardwareFlatCents', 'Hardware commission', money(a.commissionPlan.hardwareFlatCents), money(b.commissionPlan.hardwareFlatCents), 'money');
    // ── location terms ──
    push('freeLocationQuota', 'Free locations', String(a.freeLocationQuota), String(b.freeLocationQuota), 'money');
    push('additionalLocationPriceCents', 'Additional location price', money(a.additionalLocationPriceCents), money(b.additionalLocationPriceCents), 'money');
    // ── packages ──
    push('packageIds', 'Packages', a.packageIds.join(', ') || null, b.packageIds.join(', ') || null, 'presentation');
    return out;
}
//# sourceMappingURL=dealVersionDiff.js.map